import * as Yup from "yup";
import { toast } from "react-toastify";
import FormDefault from "../../components/Forms/FormDefault";
import { requestAuth } from "../../components/services/RequestService";
import dayjs from "dayjs";

const NewProcedure = (props) => {
  const { reload, onClose, isQuotation = false, dims = false } = props;

  const createProceduresForDims = async (values, dimFiles) => {
    const procedures = [];

    for (const file of dimFiles) {
      try {
        const procedureData = {
          ...values,
          numberItems: 1,
          Category: "normal",
          Step: 5,
        };

        const procedureResponse = await requestAuth(
          "post",
          isQuotation ? `/procedure/simple` : `/procedure`,
          procedureData
        );

        procedures.push({
          id: procedureResponse.data.id,
          file: file,
        });

        toast.info(`Trámite creado para ${file.name}`);
      } catch (error) {
        toast.error(`Error al crear trámite para ${file.name}`);
        throw error;
      }
    }

    return procedures;
  };

  const uploadFilesToProcedures = async (procedures, fieldId) => {
    const results = [];

    for (let i = 0; i < procedures.length; i++) {
      const procedure = procedures[i];

      try {
        toast.info(
          `Procesando DIM ${i + 1} de ${procedures.length}: ${
            procedure.file.name
          }`
        );

        const formData = new FormData();
        formData.append("Name", "DIM");
        formData.append("File", procedure.file);
        formData.append("originalName", procedure.file.name);
        formData.append("Status", "verified");
        formData.append("ProcedureId", procedure.id);

        const fileResponse = await requestAuth("post", "/files", formData);
        toast.success(`Archivo ${procedure.file.name} subido`);

        const datasetData = [
          {
            Value: fileResponse.data.url,
            ProcedureId: procedure.id,
            FieldId: fieldId,
            FileId: fileResponse.data.id,
            name: "adjuntarDim",
            url: "adjuntarDim",
            type: "fileRead",
          },
        ];

        await requestAuth("post", "/dataset", datasetData);
        toast.success(`Dataset creado para ${procedure.file.name}`);

        await readDimProcess(procedure.id, fieldId);
        toast.success(`DIM ${procedure.file.name} procesado correctamente`);

        results.push({ procedureId: procedure.id, success: true });
      } catch (error) {
        console.error(
          `Error procesando archivo ${procedure.file.name}:`,
          error
        );
        toast.error(`Error procesando ${procedure.file.name}`);
        results.push({ procedureId: procedure.id, success: false, error });
      }

      await new Promise((resolve) => setTimeout(resolve, 1000));
    }

    return results;
  };

  const readDimProcess = async (procedureId, fieldId) => {
    try {
      toast.info(`Leyendo DIM para trámite ${procedureId}...`);

      await requestAuth(
        "put",
        `/files/convertPdfToCsv/${procedureId}?FieldId=${fieldId}`,
        { name: "adjuntarDim" }
      );
      toast.success(`PDF convertido a CSV para trámite ${procedureId}`);
      await requestAuth(
        "post",
        `/files/DataDim/${procedureId}?FieldId=${fieldId}`,
        { name: "adjuntarDim" }
      );
      toast.success(`Datos DIM obtenidos para trámite ${procedureId}`);

      await requestAuth(
        "post",
        `/procedure/readH/${procedureId}?FieldId=${fieldId}`,
        { name: "adjuntarDim" }
      );
      toast.success(`Sección H leída para trámite ${procedureId}`);

      const resultL = await requestAuth(
        "post",
        `/files/sectionL/${procedureId}?FieldId=${fieldId}`,
        { name: "adjuntarDim" }
      );
      toast.success(`Sección L leída para trámite ${procedureId}`);

      return resultL;
    } catch (error) {
      console.error(`Error leyendo DIM para trámite ${procedureId}:`, error);
      toast.error(`Error leyendo DIM para trámite ${procedureId}`);
      throw error;
    }
  };

  const fieldDIM = dims
    ? [
        {
          label: "DIMs",
          name: "dims",
          typeInput: "files",
          multiple: true,
        },
      ]
    : [];

  return (
    <div>
      <FormDefault
        tittle="Agregar nuevo trámite"
        fields={[
          {
            label: "Compañia",
            name: "CompanyId",
            typeInput: "select",
            urlApi: "/company/getallcompanies",
            value: "id",
            labelOption: "razonSocial",
          },
          {
            label: "Tipo de procedimiento",
            name: "ProcedureTypeId",
            typeInput: "select",
            urlApi: "/procedureType",
            value: "id",
            labelOption: "name",
          },
          ...fieldDIM,
        ]}
        initialValues={{
          CompanyId: "",
          ProcedureTypeId: 1,
          city: "LP",
          year: dayjs().format("YYYY"),
          IsQuotation: isQuotation,
          Category: "normal",
          numberItems: 1,
        }}
        validationSchema={Yup.object().shape({
          CompanyId: Yup.string().required("Este campo es obligatorio"),
          ProcedureTypeId: Yup.string().required("Este campo es obligatorio"),
          ...(dims
            ? {
                dims: Yup.mixed().test(
                  "required",
                  "Se requiere al menos un archivo DIM",
                  (value) => {
                    if (!dims) return true;
                    return value && value.length > 0;
                  }
                ),
              }
            : {}),
        })}
        onSubmit={async (values) => {
          try {
            if (dims && values.dims && values.dims.length > 0) {
              toast.info(`Creando ${values.dims.length} trámites...`);
              const procedures = await createProceduresForDims(
                values,
                values.dims
              );

              const fieldId = 40;
              toast.info(
                `Procesando ${procedures.length} DIMs secuencialmente...`
              );
              const uploadResults = await uploadFilesToProcedures(
                procedures,
                fieldId
              );

              const successfulUploads = uploadResults.filter(
                (r) => r.success
              ).length;
              const failedUploads = uploadResults.filter(
                (r) => !r.success
              ).length;

              if (successfulUploads > 0) {
                toast.success(
                  `Se procesaron ${successfulUploads} de ${procedures.length} DIMs correctamente`
                );
                if (failedUploads > 0) {
                  toast.warning(`${failedUploads} DIMs fallaron en el proceso`);
                }
                reload();
                onClose();
              } else {
                toast.error("No se pudo procesar ningún DIM");
              }
            } else {
              await requestAuth(
                "post",
                isQuotation ? `/procedure/simple` : `/procedure`,
                values
              );
              reload();
              onClose();
              toast.success("Trámite agregado correctamente!!!");
            }
          } catch (error) {
            console.error("Error en el proceso:", error);
            toast.error("Se ha producido un error al crear el Proceso");
          }
        }}
        buttonName={dims ? "Procesar DIMs secuencialmente" : "Enviar"}
      />
    </div>
  );
};

export default NewProcedure;
